<template>
    <v-app id="app">
        <v-content transition="slide-x-transition" style="background-color: black">
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
//import AppNavigation from '@/components/AppNavigation';
//import VuebaseLayout from './layouts/BaseLayout';

export default {
    name: 'App',
    components: {
        //  AppNavigation,
    },
};
</script>

<style></style>
